import { render, staticRenderFns } from "./AtualizacaoCadastralPrimeiroAcesso.vue?vue&type=template&id=6dde51a1"
import script from "./AtualizacaoCadastralPrimeiroAcesso.vue?vue&type=script&lang=js"
export * from "./AtualizacaoCadastralPrimeiroAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports